import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-248">
      <button className="flex w-full items-center justify-between py-5 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-249">
        <span className="text-lg font-semibold text-gray-900 pr-8" data-id="element-250">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-6 w-6 text-green-600 flex-shrink-0" data-id="element-251" /> : <ChevronDown className="h-6 w-6 text-gray-400 flex-shrink-0" data-id="element-252" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0'}`} data-id="element-253">
        <p className="text-gray-600 leading-relaxed" data-id="element-254">{answer}</p>
      </div>
    </div>;
}